"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDownButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const DropDownButton_style_1 = require("./DropDownButton.style");
const ui_common_components_1 = require("@desygner/ui-common-components");
function DropDownButton({ buttonText, options, icon, buttonVariant, onSelectItem, }) {
    const [isAddInfoOpened, setIsAddInfoOpened] = (0, react_1.useState)(false);
    const [buttonTarget, setButtonTarget] = (0, react_1.useState)(undefined);
    const [dimensions, setDimensions] = (0, react_1.useState)({ top: 0, left: 0, width: 0 });
    (0, react_1.useEffect)(() => {
        if (buttonTarget) {
            const boundingClientRect = buttonTarget.getBoundingClientRect();
            setDimensions({
                top: boundingClientRect.top + boundingClientRect.height + 8,
                left: boundingClientRect.left,
                width: boundingClientRect.width,
            });
        }
    }, [buttonTarget, options]);
    return ((0, jsx_runtime_1.jsxs)(DropDownButton_style_1.StyledWrapper, { children: [(0, jsx_runtime_1.jsx)(ui_common_components_1.Button, { icon: { name: icon }, variant: buttonVariant, onClick: (event) => {
                    setButtonTarget(event.currentTarget);
                    setIsAddInfoOpened(!isAddInfoOpened);
                }, children: buttonText }), isAddInfoOpened && dimensions.width > 0 && ((0, jsx_runtime_1.jsx)(ui_common_components_1.Dropdown, { dimensions: dimensions, opened: isAddInfoOpened, onSelect: (value, index) => {
                    setIsAddInfoOpened(false);
                    return onSelectItem && onSelectItem(value, index);
                }, options: options }))] }));
}
exports.DropDownButton = DropDownButton;
//# sourceMappingURL=DropDownButton.js.map